import { __awaiter, __generator } from "tslib";
import { defineComponent, ref, onMounted } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { ArrowLeftBold } from '@element-plus/icons';
import cyclingShapeHandler from '@/api-handler/cycling';
import Map from '@/components/find-bike-lane/Map.vue';
import { useRouter, useRoute } from 'vue-router';
export default defineComponent({
    name: 'FindBikeLaneMap',
    components: {
        BaseLayout: BaseLayout,
        ArrowLeftBold: ArrowLeftBold,
        Map: Map,
    },
    setup: function () {
        var _this = this;
        var router = useRouter();
        var route = useRoute();
        var bikeLaneGeomery = ref([]);
        var laneCenter = ref(null);
        var starAndEnd = ref([]);
        var laneDistance = ref(15);
        var goBack = function () {
            router.back();
        };
        var getBikeLaneGeomery = function (city, routeName) { return __awaiter(_this, void 0, void 0, function () {
            var res, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, cyclingShapeHandler.getFilteredCyclingShape(city, routeName)];
                    case 1:
                        res = _b.sent();
                        if (!res) return [3 /*break*/, 3];
                        _a = bikeLaneGeomery;
                        return [4 /*yield*/, res.data[0].Geometry.split('((')[1].split('))')[0].split(',')
                                .map(function (item) { return item.split(' '); }).map(function (item) { return ({
                                lat: Number(item[1]),
                                lng: Number(item[0])
                            }); })];
                    case 2:
                        _a.value = _b.sent();
                        laneCenter.value = bikeLaneGeomery.value[Math.ceil(bikeLaneGeomery.value.length / 2)];
                        starAndEnd.value.push(bikeLaneGeomery.value[0]);
                        starAndEnd.value.push(bikeLaneGeomery.value[bikeLaneGeomery.value.length - 1]);
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.log(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        onMounted(function () {
            var _a = route.params, city = _a.city, routeName = _a.routeName, distance = _a.distance;
            var distanceKm = Number(distance) / 1000;
            if (distanceKm > 3) {
                laneDistance.value = 13;
            }
            getBikeLaneGeomery(city, routeName);
        });
        return {
            bikeLaneGeomery: bikeLaneGeomery,
            laneCenter: laneCenter,
            starAndEnd: starAndEnd,
            laneDistance: laneDistance,
            goBack: goBack,
        };
    }
});
